
import { ReactComponent as InletPipeSvg } from '@/commons/icons/new/havc/inlet-pipe.svg';
import { ReactComponent as AttachmentSvg } from '@/commons/icons/new/havc/attachment.svg';
import { ReactComponent as ConnectSvg } from '@/commons/icons/new/havc/connect.svg';
import { ReactComponent as DeviceSvg } from '@/commons/icons/new/havc/device.svg';
import { ReactComponent as MaterialSvg } from '@/commons/icons/new/material.svg';
import { SideStatus } from '@/commons/context/side-store';
import { SideContext } from '@/App';
import { useContext } from 'react';
import { graphicStore } from '@/commons/store/graphic-store';
import { SIDE_TYPE } from '@/commons/enums/side-type';
import localStore from '@/commons/store/local-store';
import { MAJOR } from '@/commons/constants/major';

import { ReactComponent as ZhuanyecanzhaoSvg } from '@/commons/icons/menu/zhuanyecanzhao.svg';
import { ReactComponent as ZhouxianSvg } from '@/commons/icons/menu/zhouxian.svg';
import { ReactComponent as YinyongloucengSvg } from '@/commons/icons/menu/yinyonglouceng.svg';
import { ReactComponent as YinyongzhouwangSvg } from '@/commons/icons/menu/yinyongzhouwang.svg';

import { ReactComponent as FamenSvg } from '@/commons/icons/menu/havc/famen.svg';
import { ReactComponent as GuandaoSvg } from '@/commons/icons/menu/havc/guandao.svg';
import { ReactComponent as GuoluSvg } from '@/commons/icons/menu/havc/guolu.svg';
import { ReactComponent as JietouSvg } from '@/commons/icons/menu/havc/jietou.svg';
import { ReactComponent as KongtiaoSvg } from '@/commons/icons/menu/havc/kongtiao.svg';
import { ReactComponent as SanreqiSvg } from '@/commons/icons/menu/havc/sanreqi.svg';
import { ReactComponent as TongfengkouSvg } from '@/commons/icons/menu/havc/tongfengkou.svg';
import { ReactComponent as PeijianSvg } from '@/commons/icons/menu/havc/peijian.svg';



export default function HavcMenu() {
    const sideContext = useContext<SideStatus>(SideContext);

    const onClick = (route: string, majorUuid?: string) => {
        graphicStore.extraContext.listeners.signals.onOpeCommandControlEnd.dispatch();
        sideContext.setSelectedPanelValue(route);
        sideContext.setSelectedMajorUuid(majorUuid);
        localStore.setSelectedMajor(majorUuid);
    }

    return (
        <div className='tn-menu-container'>
            <div className='ope-panel'>
                <div className='ope-col-area'>
                    <div className='ope-btn'>
                        <div className='ope-col'>
                            <div className='ope-item disabled' onClick={() => { }}>
                                <div className='icon'><YinyongzhouwangSvg /></div>
                                <div className='name'>引用轴网</div>
                            </div>
                            <div className='ope-item disabled' onClick={() => { }}>
                                <div className='icon'><ZhouxianSvg /></div>
                                <div className='name'>轴线</div>
                            </div>
                            <div className='ope-item disabled' onClick={() => { }}>
                                <div className='icon'><YinyongloucengSvg /></div>
                                <div className='name'>引用楼层</div>
                            </div>
                        </div>
                        <div className='ope-col'>
                            <div className='ope-item disabled' onClick={() => { }}>
                                <div className='icon'><ZhuanyecanzhaoSvg /></div>
                                <div className='name'>专业参照</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='ope-col-area'>
                    <div className='ope-btn'>
                        <div className='ope-col'>
                            <div className='ope-item name2 disabled' onClick={() => { }}>
                                <div className='icon'><GuoluSvg /></div>
                                <div className='name'>锅炉</div>
                            </div>
                            <div className='ope-item name2 disabled' onClick={() => { }}>
                                <div className='icon'><KongtiaoSvg /></div>
                                <div className='name'>空调</div>
                            </div>
                            <div className='ope-item name2' onClick={() => { onClick(SIDE_TYPE.tunnel_block) }}>
                                <div className='icon'><GuandaoSvg /></div>
                                <div className='name'>管道</div>
                            </div>
                        </div>
                        <div className='ope-col'>
                            <div className='ope-item name2' onClick={() => { onClick(SIDE_TYPE.connect_block) }}>
                                <div className='icon'><JietouSvg /></div>
                                <div className='name'>接头</div>
                            </div>
                            <div className='ope-item name2 disabled' onClick={() => { }}>
                                <div className='icon'><FamenSvg /></div>
                                <div className='name'>阀门</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='ope-col-area'>
                    <div className='ope-btn'>
                        <div className='ope-col'>
                            <div className='ope-item name3 disabled' onClick={() => { }}>
                                <div className='icon'><SanreqiSvg /></div>
                                <div className='name'>散热器</div>
                            </div>
                            <div className='ope-item name3 disabled' onClick={() => { }}>
                                <div className='icon'><TongfengkouSvg /></div>
                                <div className='name'>通风口</div>
                            </div>
                            <div className='ope-item name3' onClick={() => { onClick(SIDE_TYPE.attachment_block) }}>
                                <div className='icon'><PeijianSvg /></div>
                                <div className='name'>配件</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='ope-col-area'>
                    <div className='ope-btn'>
                        <div className='ope-col'>
                            <div className='ope-item name2' onClick={() => { onClick(SIDE_TYPE.material, MAJOR.HVAC) }}>
                                <div className='icon'><MaterialSvg /></div>
                                <div className='name'>材料</div>
                            </div>
                            <div className='ope-item name2' onClick={() => { onClick(SIDE_TYPE.device_block) }}>
                                <div className='icon'><DeviceSvg /></div>
                                <div className='name'>设备</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}